export default __webpack_public_path__ + "static/media/home-travel-agency-destination-img05.ddc949ce.jpg";